import {Box} from "@mui/material";
import EquipmentFilterButtons from "../EquipmentFilterButtons/EquipmentFilterButtons";
import EquipmentDropdown from "../../../Inputs/EquipmentDropdown/EquipmentDropdown";
import EquipmentTableCard from "../EquipmentTableCard/EquipmentTableCard";

const TagsSection = (
  {
    tagsIds = [],
    clickAllTags,
    handleClickedTags,
    setSelectedTags,
    clickedTags,
    removeAllClickedTags,
    selectedTags,
    fixedHeaderContent,
    tableBodyRowContent,
    processedEquipment,
    tagsInputs,
    handleSuccessAdd,
    isEquipmentLoading = false,
    openTagsExportModal,
  }
) => {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <EquipmentFilterButtons
          type="tag"
          options={tagsIds}
          selectedEquipment={selectedTags}
          clickedEquipment={clickedTags}
          handleClickEquipment={handleClickedTags}
          removeAllClickedEquipment={removeAllClickedTags}
          addAllClickedEquipment={clickAllTags}
          color="#16604B"
        />
        <EquipmentDropdown
          type="tag"
          options={tagsIds}
          selectedEquipment={selectedTags}
          handleSelectionChange={(value) => {
            setSelectedTags(value);
          }}
          borderColor="#16604B"
          iconColor="#16604B"
          textColor="#16604B"
        />
      </Box>

      <EquipmentTableCard
        type="tag"
        textColor="#16604B"
        addBtnBackground="#89D8C2"
        fixedHeaderContent={fixedHeaderContent}
        tableBodyRowContent={tableBodyRowContent}
        processedEquipment={processedEquipment}
        equipmentInputs={tagsInputs}
        handleAddEquipmentSuccess={handleSuccessAdd}
        isLoading={isEquipmentLoading}
        openTagsExportModal={openTagsExportModal}
      />
    </Box>
  )
};

export default TagsSection;
